export default __webpack_public_path__ + "static/media/2319.2899e2b7.png";